import { Component } from "@angular/core";
import { AuthenticationService } from "src/app/core/services/auth.service";

@Component({
  selector: "app-no-clinic-access",
  templateUrl: "./no-clinic-access.component.html",
  styleUrls: ["./no-clinic-access.component.scss"],
})
export class NoClinicAccessComponent {
  signingOut = false;

  constructor(private readonly _authService: AuthenticationService) {}

  signOut(): void {
    if (this.signingOut) {
      return;
    }
    this.signingOut = true;
    this._authService.logoutFromAllApps();
  }
}
